module.exports = __webpack_public_path__ + "img/LearnToBeLaptopSavvy.1de62949.png";